// 新能源页面API接口
import { http } from '@/utils/index'

// 获取新能源页面所有数据
export const getNewEnergyData = () => {
  return http.request("get", "/new-energy/data", {})
}

// 获取新能源案例页面数据
export const getNewEnergyCaseData = () => {
  return http.request("get", "/new-energy/case-data", {})
}

// 获取新能源整车运输页面数据
export const getNewEnergyProductionData = () => {
  return http.request("get", "/new-energy/production-data", {})
}

// 获取新能源页面配置
export const getNewEnergyConfig = () => {
  return http.request("get", "/new-energy/config", {})
}

// 获取新能源横幅配置
export const getNewEnergyBanner = () => {
  return http.request("get", "/new-energy/banner", {})
}

// 获取新能源公司实力配置
export const getNewEnergyStrength = () => {
  return http.request("get", "/new-energy/strength", {})
}

// 获取新能源服务优势配置
export const getNewEnergyAdvantages = () => {
  return http.request("get", "/new-energy/advantages", {})
}

// 获取新能源集装箱代理配置
export const getNewEnergyAgency = () => {
  return http.request("get", "/new-energy/agency", {})
}

// 获取新能源项目管理配置
export const getNewEnergyProject = () => {
  return http.request("get", "/new-energy/project", {})
}

// 获取新能源公司资质配置
export const getNewEnergyQualification = () => {
  return http.request("get", "/new-energy/qualification", {})
}

// 获取新能源服务范围配置
export const getNewEnergyScope = () => {
  return http.request("get", "/new-energy/scope", {})
}
